import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import InnerBox from '@repo/ui/inner-box'
import Loader from '@repo/ui/loader'
import { LogSection } from '@repo/ui/log-section'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getTeflLecComments } from '../../../api/tefl/tefl-lec-comments/get-tefl-lec-comments'

type Props = {
  id: number
}

const TeflLecComments = ({ id }: Props) => {
  const { data: teflLecComments, isPending } = useQuery({
    queryKey: ['tefl-lec-comments'],
    queryFn: () => getTeflLecComments({ teflId: id, filter: { sharedToOl: true } }),
    enabled: !!id
  })

  if (isPending || !teflLecComments) return <Loader center />

  return (
    <InnerBox className="rounded-xl">
      <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
        LEC comments
      </Typography>
      <div className="h-4" />

      {!teflLecComments || teflLecComments.data.length === 0 ? (
        <Typography variant="label-semibold">No comments yet</Typography>
      ) : (
        <LogSection
          data={
            teflLecComments?.data?.map((comment) => ({
              comment: comment.comment,
              updatedAt: new Date(comment.updatedAt)
            })) || []
          }
          dateFormatter={(date) => DateFormatter.ddMMyyyyHHmm(date)}
        />
      )}
    </InnerBox>
  )
}

export default TeflLecComments
